(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_personalizador"] && !Shopify.designMode) return;
  try {
    // Hide quantity selector and remove button on Planet (smart-cart) addon items.
  // Addon items are identified by .smart-cart-line-properties containing "Producto base".
  (function () {
    if (window.__persoPlanetAddonCtrlBound) return;
    window.__persoPlanetAddonCtrlBound = true;

    function markAddonItems() {
      document.querySelectorAll('.smart-cart-line-properties').forEach(function (span) {
        if (span.textContent.indexOf('Producto base') === -1) return;
        var line = span.closest('.smart-cart-line');
        if (line && !line.dataset.persAddon) {
          line.dataset.persAddon = 'true';
        }
      });
    }

    var _addonObserver = new MutationObserver(markAddonItems);

    function attachAddonObserver() {
      var container = document.querySelector('.smart-cart-container, .smart-cart-modal-content');
      if (container && !container.__persAddonObserved) {
        container.__persAddonObserved = true;
        _addonObserver.observe(container, { childList: true, subtree: true });
        markAddonItems();
      }
    }

    attachAddonObserver();

    var _mountObserver = new MutationObserver(attachAddonObserver);
    _mountObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-countdown')) {
    // Theme editor: block selected in the sidebar, kept visible so it can be edited
    let editorSelectedBlock = null;

    class DeliveryCountdown extends HTMLElement {
      connectedCallback() {
        const { dataset } = this;

        this.deliveryDays = this.toInteger(dataset.deliveryDays, 1);
        this.cutoffSeconds = this.toInteger(dataset.cutoffHour, 13) * 3600;
        this.windowSeconds = this.toInteger(dataset.windowHours, 4) * 3600;
        this.holidays = this.parseJson(dataset.holidays, []);
        this.weekdays = this.parseJson(dataset.weekdays, []);
        this.months = this.parseJson(dataset.months, []);
        this.datePattern = dataset.datePattern || '{day} {month}';
        this.isAvailable = dataset.available === 'true';
        this.shipsOnSaturday = dataset.shipsOnSaturday === 'true';
        this.countdownDays = (dataset.countdownDays || '').split(',').filter(Boolean).map(Number);
        this.formatter = this.createFormatter(dataset.timezone);
        this.utcOffsetMinutes = this.parseUtcOffset(dataset.utcOffset);

        this.dateElement = this.querySelector('[data-delivery-date]');
        this.countdownElements = this.querySelectorAll('[data-countdown]');
        this.hoursElement = this.querySelector('[data-countdown-hours]');
        this.minutesElement = this.querySelector('[data-countdown-minutes]');
        this.secondsElement = this.querySelector('[data-countdown-seconds]');

        this.update = this.update.bind(this);
        this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
        this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
        document.addEventListener('variant:update', this.handleVariantUpdate);
        document.addEventListener('visibilitychange', this.update);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.update();
        this.intervalId = window.setInterval(this.update, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.intervalId);
        document.removeEventListener('variant:update', this.handleVariantUpdate);
        document.removeEventListener('visibilitychange', this.update);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      }

      toInteger(value, fallback) {
        const number = parseInt(value, 10);
        return Number.isFinite(number) ? number : fallback;
      }

      parseJson(value, fallback) {
        try {
          return JSON.parse(value);
        } catch (error) {
          return fallback;
        }
      }

      createFormatter(timeZone) {
        if (!timeZone) return null;
        try {
          return new Intl.DateTimeFormat('en-US', {
            timeZone,
            hourCycle: 'h23',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
          });
        } catch (error) {
          return null;
        }
      }

      parseUtcOffset(value) {
        const match = /^([+-])(\d{2})(\d{2})$/.exec(value || '');
        if (!match) return 0;
        const minutes = parseInt(match[2], 10) * 60 + parseInt(match[3], 10);
        return match[1] === '-' ? -minutes : minutes;
      }

      /**
       * Today's date (as a UTC midnight Date) and seconds since midnight, in the store time zone.
       */
      getStoreNow() {
        const now = new Date();

        if (this.formatter) {
          const parts = {};
          this.formatter.formatToParts(now).forEach((part) => {
            parts[part.type] = parseInt(part.value, 10);
          });
          return {
            today: new Date(Date.UTC(parts.year, parts.month - 1, parts.day)),
            seconds: (parts.hour % 24) * 3600 + parts.minute * 60 + parts.second,
          };
        }

        const shifted = new Date(now.getTime() + this.utcOffsetMinutes * 60000);
        return {
          today: new Date(Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate())),
          seconds: shifted.getUTCHours() * 3600 + shifted.getUTCMinutes() * 60 + shifted.getUTCSeconds(),
        };
      }

      isHoliday(date) {
        return this.holidays.includes(date.toISOString().slice(0, 10));
      }

      /** Delivery days: Monday to Friday, except market holidays */
      isBusinessDay(date) {
        const weekday = date.getUTCDay();
        if (weekday === 0 || weekday === 6) return false;
        return !this.isHoliday(date);
      }

      /** Days when orders leave the warehouse: business days, plus Saturdays if enabled */
      isDispatchDay(date) {
        if (date.getUTCDay() === 6) return this.shipsOnSaturday && !this.isHoliday(date);
        return this.isBusinessDay(date);
      }

      /** Days checked in the block, except market holidays, whether or not orders leave that day */
      isCountdownDay(date) {
        return this.countdownDays.includes(date.getUTCDay()) && !this.isHoliday(date);
      }

      /**
       * Seconds to the next cut-off: today's if it has not passed and today is a countdown day,
       * otherwise the next countdown day's (it matters when the window spans past midnight)
       */
      getSecondsToNextCutoff(today, seconds) {
        if (this.isCountdownDay(today) && seconds < this.cutoffSeconds) return this.cutoffSeconds - seconds;

        const date = new Date(today.getTime());
        for (let days = 1; days <= 7; days += 1) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (this.isCountdownDay(date)) return days * 86400 - seconds + this.cutoffSeconds;
        }
        return Infinity;
      }

      /**
       * The order leaves today if today is a dispatch day and the cut-off has not passed,
       * otherwise on the next dispatch day; it arrives N business days later.
       * With Saturdays off, Monday to Friday give the same dates as the Shipping Info block.
       */
      getDeliveryDate(today, isPastCutoff) {
        const date = new Date(today.getTime());
        let guard = 0;

        if (isPastCutoff || !this.isDispatchDay(date)) {
          do {
            date.setUTCDate(date.getUTCDate() + 1);
            guard += 1;
          } while (!this.isDispatchDay(date) && guard < 370);
        }

        let added = 0;
        while (added < this.deliveryDays && guard < 740) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (this.isBusinessDay(date)) added += 1;
          guard += 1;
        }

        return date;
      }

      formatDate(date) {
        return this.datePattern
          .replace('{weekday}', this.weekdays[date.getUTCDay()] || '')
          .replace('{day}', String(date.getUTCDate()))
          .replace('{month}', this.months[date.getUTCMonth()] || String(date.getUTCMonth() + 1));
      }

      setText(element, text) {
        if (element && element.textContent !== text) element.textContent = text;
      }

      update() {
        const { today, seconds } = this.getStoreNow();
        const remaining = this.getSecondsToNextCutoff(today, seconds);
        const showCountdown = this.isAvailable && this.isCountdownDay(today) && remaining <= this.windowSeconds;
        const deliveryDate = this.getDeliveryDate(today, seconds >= this.cutoffSeconds);

        if (!this.updateBlockVisibility(showCountdown)) {
          this.syncFallbackDates(deliveryDate);
          return;
        }

        this.setText(this.dateElement, this.formatDate(deliveryDate));

        this.countdownElements.forEach((element) => {
          if (element.hidden === showCountdown) element.hidden = !showCountdown;
        });
        if (!showCountdown) return;

        this.setText(this.hoursElement, String(Math.floor(remaining / 3600)));
        this.setText(this.minutesElement, String(Math.floor((remaining % 3600) / 60)).padStart(2, '0'));
        this.setText(this.secondsElement, String(remaining % 60).padStart(2, '0'));
      }

      /**
       * Takes turns with the Shipping Info blocks of the same section: this block shows while
       * the countdown runs and those blocks the rest of the time (CSS hides them while this
       * block is visible). Without them this block always shows. In the theme editor the
       * selected block stays visible. Returns whether this block is visible.
       */
      updateBlockVisibility(showCountdown) {
        const scope = this.closest('.shopify-section, dialog');
        this.fallbackBlocks = scope ? Array.from(scope.querySelectorAll('.shipping-info')) : [];

        const isFallbackSelected = this.fallbackBlocks.includes(editorSelectedBlock);
        const showBlock =
          editorSelectedBlock === this || (!isFallbackSelected && (showCountdown || !this.fallbackBlocks.length));

        if (this.hidden === showBlock) this.hidden = !showBlock;
        return showBlock;
      }

      /**
       * Shipping Info computes its date once on page load, with the visitor's clock and without
       * dispatch days, so it can disagree with this block (after a live cut-off, on weekends,
       * outside the store time zone). Writes this block's date in that block's own format
       * (same tokens as its inline script).
       */
      syncFallbackDates(date) {
        const day = date.getUTCDate();
        const month = date.getUTCMonth() + 1;

        this.fallbackBlocks.forEach((block) => {
          const calcElement = block.querySelector('[data-shipping-delivery-calc]');
          const dateElement = calcElement && calcElement.querySelector('[data-delivery-date]');
          if (!dateElement || !calcElement.dataset.pattern) return;

          const months = this.parseJson(calcElement.dataset.months, []);
          const text = calcElement.dataset.pattern
            .replace('{day}', String(day))
            .replace('{dd}', String(day).padStart(2, '0'))
            .replace('{month}', months[month - 1] || String(month).padStart(2, '0'))
            .replace('{mm}', String(month).padStart(2, '0'))
            .replace('{year}', String(date.getUTCFullYear()));
          this.setText(dateElement, text);
        });
      }

      /** The editor fires it again after re-rendering the section, with the new element */
      handleBlockSelect(event) {
        editorSelectedBlock = event.target;
        this.update();
      }

      handleBlockDeselect(event) {
        if (event.target === editorSelectedBlock) editorSelectedBlock = null;
        this.update();
      }

      handleVariantUpdate(event) {
        const source = event.target instanceof Element ? event.target.closest('.shopify-section, dialog') : null;
        if (!source || source !== this.closest('.shopify-section, dialog')) return;

        const resource = event.detail && event.detail.resource;
        const variantsElement = this.querySelector('[data-delivery-countdown-variants]');
        const variants = this.parseJson(variantsElement ? variantsElement.textContent : '', {});

        // No resource means the selected combination does not exist
        const variant = resource
          ? variants[resource.id] || { available: Boolean(resource.available), qty: 0, managed: false, price: resource.price || 0 }
          : { available: false, qty: 0, managed: false, price: 0 };

        this.isAvailable = Boolean(variant.available);
        this.updateAvailability(variant);
        if (resource) this.updateFreeShipping(variant.price);
        this.update();
      }

      updateAvailability(variant) {
        const element = this.querySelector('[data-availability]');
        if (!element) return;

        const { dataset } = this;
        const isLowStock =
          variant.available &&
          dataset.showStockCount === 'true' &&
          variant.managed &&
          variant.qty > 0 &&
          variant.qty <= this.toInteger(dataset.lowStockThreshold, 6);
        const state = !variant.available ? 'unavailable' : isLowStock ? 'low-stock' : 'available';

        element.classList.remove(
          'delivery-countdown__availability--available',
          'delivery-countdown__availability--low-stock',
          'delivery-countdown__availability--unavailable'
        );
        element.classList.add(`delivery-countdown__availability--${state}`);

        const textElement = element.querySelector('[data-availability-text]');
        if (!textElement) return;
        if (state === 'low-stock') {
          textElement.textContent = (dataset.lowStockText || '').replace('[quantity]', String(variant.qty));
        } else {
          textElement.textContent = state === 'available' ? dataset.availableText : dataset.unavailableText;
        }
      }

      updateFreeShipping(price) {
        const header = this.querySelector('[data-free-shipping]');
        if (!header) return;

        const qualifies = (parseInt(price, 10) || 0) >= (parseInt(header.dataset.thresholdCents, 10) || 0);
        const qualifiedElement = header.querySelector('[data-free-shipping-qualified]');
        const thresholdElement = header.querySelector('[data-free-shipping-threshold]');
        if (qualifiedElement) qualifiedElement.hidden = !qualifies;
        if (thresholdElement) thresholdElement.hidden = qualifies;
      }
    }

    customElements.define('delivery-countdown', DeliveryCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-slideshow"] && !Shopify.designMode) return;
  try {
    class SocialSlideshowBlock extends HTMLElement {
    connectedCallback() {
      if (this.dataset.socialSlideshowHydrated === 'true') return;

      if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        this.hydrate();
        return;
      }

      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;
          this.visibilityObserver?.disconnect();
          this.visibilityObserver = undefined;
          this.hydrate();
        },
        { rootMargin: '250px 0px' }
      );

      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    hydrate() {
      const template = this.querySelector('template[data-social-slideshow-template]');
      if (!template) return;

      const placeholder = this.querySelector('[data-social-slideshow-placeholder]');
      placeholder?.replaceWith(template.content.cloneNode(true));
      template.remove();
      this.dataset.socialSlideshowHydrated = 'true';
    }
  }

  if (!customElements.get('social-slideshow-block')) {
    customElements.define('social-slideshow-block', SocialSlideshowBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    class StickyAddToCart extends HTMLElement {
    #isAdding = false;
    #feedbackTimeout = null;

    constructor() {
      super();
      this.triggerSelector = this.dataset.triggerElement || '[data-add-to-cart-button], product-form-component, .product-form__submit, [name="add"]';
      this.triggerElement = null;
      this.observer = null;
      this.isVisible = false;
    }

    connectedCallback() {
      this.init();
      this.setupButton();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.#feedbackTimeout) {
        clearTimeout(this.#feedbackTimeout);
      }
    }

    init() {
      this.findTriggerElement();

      if (this.triggerElement) {
        this.setupIntersectionObserver();
      } else {
        setTimeout(() => {
          this.findTriggerElement();
          if (this.triggerElement) {
            this.setupIntersectionObserver();
          }
        }, 500);
      }
    }

    findTriggerElement() {
      const selectors = this.triggerSelector.split(',').map(s => s.trim());

      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) {
          this.triggerElement = element;
          break;
        }
      }
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.hide();
          } else {
            const rect = entry.boundingClientRect;
            if (rect.top < 0 || rect.bottom < 0) {
              this.show();
            }
          }
        });
      }, options);

      this.observer.observe(this.triggerElement);
    }

    setupButton() {
      const button = this.querySelector('.sticky-atc__button');
      if (!button) return;

      button.addEventListener('click', (e) => {
        e.preventDefault();
        const action = button.dataset.stickyAtcAction;

        if (action === 'add') {
          this.handleAddToCart(button);
        } else {
          this.handleScrollToVariants();
        }
      });
    }

    handleScrollToVariants() {
      // Try the custom scroll-to-variants selector first, then fall back to trigger element
      const scrollSelector = this.dataset.scrollToVariants;
      let target = null;

      if (scrollSelector) {
        target = document.querySelector(scrollSelector);
      }

      if (!target) {
        target = this.triggerElement;
      }

      if (target) {
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10);
        const offset = headerHeight + 20;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top, behavior: 'smooth' });
      }
    }

    handleAddToCart(button) {
      if (this.#isAdding || button.disabled) return;

      const variantId = this.dataset.variantId;
      if (!variantId) return;

      // Prefer the native product form. Clicking its submit button runs the
      // theme's full add-to-cart flow, which serialises the whole form —
      // including line-item properties and bundled items[] injected by other
      // blocks (e.g. the weight personalization accordion). A bare /cart/add.js
      // would drop that personalization complement.
      const nativeButton = this.#getNativeAddButton();
      if (nativeButton) {
        this.#isAdding = true;
        this.animateAddToCart(button);
        nativeButton.click();
        setTimeout(() => { this.#isAdding = false; }, 2000);
        return;
      }

      // Fallback: no product form on the page — add the bare variant directly.
      this.#directAddToCart(button, variantId);
    }

    // Finds the native add-to-cart button, preferring the form that matches
    // this product. Returns it even when disabled so we never silently bypass
    // a blocked add (clicking a disabled button is a no-op).
    #getNativeAddButton() {
      const productId = this.dataset.productId;
      const components = document.querySelectorAll('product-form-component');
      let fallback = null;

      for (const component of components) {
        const nativeButton = component.querySelector('form button[name="add"]');
        if (!nativeButton) continue;
        if (productId && component.dataset.productId === productId) return nativeButton;
        fallback = fallback || nativeButton;
      }

      return fallback;
    }

    #directAddToCart(button, variantId) {
      this.#isAdding = true;

      // Animate button immediately (same as native buy button)
      this.animateAddToCart(button);

      // Collect cart-items-component section IDs so the response includes
      // pre-rendered cart drawer HTML (prevents empty drawer flash)
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      const sectionIds = [];
      cartItemsComponents.forEach(item => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          sectionIds.push(item.dataset.sectionId);
        }
      });

      const body = JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: sectionIds.join(',')
      });

      fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      })
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            console.error('[StickyATC] Error:', response.description);
            this.#isAdding = false;
            return;
          }

          // Dispatch cart update event WITH sections so the drawer morphs instantly
          this.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: variantId,
              data: {
                source: 'product-form-component',
                itemCount: 1,
                productId: this.dataset.productId,
                sections: response.sections
              }
            }
          }));

          this.#isAdding = false;
        })
        .catch(error => {
          console.error('[StickyATC] Fetch error:', error);
          this.#isAdding = false;
        });
    }

    animateAddToCart(button) {
      if (this.#feedbackTimeout) clearTimeout(this.#feedbackTimeout);

      if (!button.classList.contains('atc-added')) {
        button.classList.add('atc-added');
      }

      this.#feedbackTimeout = setTimeout(() => {
        setTimeout(() => {
          button.classList.remove('atc-added');
        }, 10);
      }, 2000);
    }

    show() {
      if (!this.isVisible) {
        this.isVisible = true;
        this.classList.add('is-visible');
      }
    }

    hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.classList.remove('is-visible');
      }
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-metafield"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-metafield')) {
    class VideoMetafield extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('[data-play]');
        if (!this.button) return;

        const poster = this.querySelector('.video-metafield__poster');
        if (poster && poster.dataset.fallback) {
          const useFallback = () => {
            poster.src = poster.dataset.fallback;
          };
          poster.addEventListener('error', useFallback, { once: true });
          if (poster.complete && poster.naturalWidth <= 120) useFallback();
        }

        this.onPlay = () => {
          const embedSrc = this.dataset.embedSrc;

          if (!embedSrc) {
            this.video.controls = true;
            this.video.play();
            this.button.hidden = true;
            return;
          }

          const cookiebot = window.Cookiebot;
          const needsConsent = this.dataset.consentFree !== 'true' && cookiebot && cookiebot.consent && !cookiebot.consent.marketing;
          if (needsConsent) {
            cookiebot.renew();
            return;
          }

          const iframe = document.createElement('iframe');
          iframe.className = 'video-metafield__video';
          iframe.src = embedSrc;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.title = this.button.getAttribute('aria-label');
          iframe.setAttribute('data-cookieconsent', 'ignore');
          this.append(iframe);
          this.button.hidden = true;
        };
        this.button.addEventListener('click', this.onPlay);
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onPlay);
      }
    }

    customElements.define('video-metafield', VideoMetafield);
  }
  } catch(e) { console.error(e); }
})();

})();
